import { PageMeta } from 'types/Pages'

export const PageMetaSetting: PageMeta = {
  location: '/company/clinic/new',
  title: 'Cadastrar Clinica',
  endpoint: '/app/company',
}
